"use client";

import { Facebook, Instagram, Twitter } from "lucide-react";
import type React from "react";
import type { FooterSocialData } from "@/types";

export interface FooterSocialProps {
  socialData: FooterSocialData;
}

const iconMap = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
};

const FooterSocial: React.FC<FooterSocialProps> = ({ socialData }) => {
  const { socialLinks, navigationLinks, copyright, heritage } = socialData;

  return (
    <>
      {/* Social & Legal */}
      <div className="border-t border-black/10 pt-6">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
          {/* Social Links */}
          <div className="flex gap-6">
            {socialLinks.map((link) => {
              const IconComponent = iconMap[link.icon as keyof typeof iconMap];

              return (
                <a
                  key={link.icon}
                  href={link.href}
                  aria-label={link.label}
                  className="w-12 h-12 border border-black/20 rounded-full flex items-center justify-center hover:border-black/40 hover:bg-black/5 transition-all duration-300 group"
                >
                  {IconComponent && (
                    <IconComponent className="w-5 h-5 text-black/60 group-hover:text-black transition-colors" />
                  )}
                </a>
              );
            })}
          </div>

          {/* Navigation */}
          <div className="flex flex-wrap gap-8 text-sm text-black/60 font-light tracking-wide">
            {navigationLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="hover:text-black transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="text-sm text-black/50 font-light tracking-wide">
            {copyright}
          </div>
        </div>
      </div>

      {/* Heritage Line */}
      <div className="text-center mt-6 pt-4 border-t border-black/5">
        <p className="text-xs text-black/40 font-light tracking-[0.2em] uppercase">
          {heritage}
        </p>
      </div>
    </>
  );
};
export default FooterSocial;
